'use client';

import React, { useState, useEffect, useCallback } from 'react';
import { FaWhatsapp, FaTelegram, FaInstagram, FaPhoneAlt, FaViber } from 'react-icons/fa';

const PHONE = '+375296047061'; 

const ICONS = [
  {
    platform: 'WhatsApp',
    icon: <FaWhatsapp className="w-5 h-5" />,
    href: `https://wa.me/${PHONE.replace(/\D/g, '')}`,
  },
  {
    platform: 'Telegram',
    icon: <FaTelegram className="w-5 h-5" />,
    href: `https://t.me/slavstroy82`, 
  },
  {
    platform: 'Viber',
    icon: <FaViber className="w-5 h-5" />,
    href: `viber://chat?number=${PHONE.replace(/\D/g, '')}`,
  },
  {
    platform: 'Instagram',
    icon: <FaInstagram className="w-5 h-5" />,
    href: 'https://www.instagram.com/SLAV_STROY_', 
  },
  {
    platform: 'Phone',
    icon: <FaPhoneAlt className="w-5 h-5" />,
    href: `tel:${PHONE}`,
  },
] as const;

export default function FloatingContactBar() {
  const [isVisible, setIsVisible] = useState(true);

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolledToBottom = scrollTop >= scrollHeight - 1; // -1 для погрешности
    setIsVisible(!scrolledToBottom);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  // if (!isVisible) return null;

  return (
    <>
      <aside className="fixed top-1/2 right-6 z-50 flex -translate-y-1/2 flex-col gap-3">
        {ICONS.map(({ platform, icon, href }) => (
          <a
            key={platform}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Связаться через ${platform}`}
            className="flex size-12 items-center justify-center rounded-full bg-background text-primary shadow-lg hover:bg-primary hover:text-primary-foreground active:scale-[0.96] transition-all"
          >
            {icon}
          </a>
        ))}
      </aside>
    </>
  );
}